import { SessionMessage } from '../session/SessionMessage';

// Tablet / phone /error route - same IBISengage message page as the desktop one (screens/Error.js).
const ResponsiveError = () => <SessionMessage />;

export default ResponsiveError;
